module.exports = __webpack_public_path__ + "img/scroll03.cbb3825.png";